<template>
  <div>
    <h2 class="section-title m-4 text-center text-lg px-5 py-3">Cookieポリシー</h2>
    <div class="article">
      <p>東日本旅客鉄道株式会社は、ウェブサイト「https://niigata-choinavi.com/」（以下、「当サイト」と記載します）において、Cookieを使用して一定の情報を収集しています。</p>

<p>1．Cookieについて<br/>
Cookieとはサイトがお客さまのパソコン等のブラウザに情報を保存し、あとで取り出すことができる技術のひとつです。</p>

<p>2．Cookieの利用状況<br/>
当サイトでは、当サイトのアクセス状況の把握のために、「Google Analytics」を利用しています。「Google Analytics」はサードパーティCookieを使用しており、当サイト内におけるお客さまの行動履歴（アクセスしたURL、コンテンツ、参照順など）を取得することがあります。
取得したCookie情報等は、以下の企業のプライバシーポリシーに従って取り扱われます。Cookieの利用に関するオプトアウト手続を行う場合は、以下のオプトアウトページにアクセスし手順に従ってください。</p>

<p>Google LLC<br/>
利用規約：<a class="link" href="https://marketingplatform.google.com/about/analytics/terms/jp/">https://marketingplatform.google.com/about/analytics/terms/jp/</a><br/>
プライバシーポリシー：<a class="link" href="https://policies.google.com/privacy">https://policies.google.com/privacy</a><br/>
オプトアウトページ：<a class="link" href="https://policies.google.com/technologies/ads?hl=ja&gl=jp">https://policies.google.com/technologies/ads?hl=ja&gl=jp</a><br/>
利用目的：当サイトのアクセス状況の把握</p>

    </div>
    <div class="mt-4">
      <button @click="backTop" class="back_button">
        <span class="w-full -ml-5">戻る</span></button>
    </div>
  </div>
</template>
  
  <script>
  // import { mapGetters } from 'vuex'
  // import moment from "moment";
  // import Constants from "../constants"
  
  export default {
    data () {
      return {
        message: {}
      }
    },
    name: 'CookiePolicy',
    methods: {
      backTop: function () {
        this.$router.push({ name: 'root', params: { lang: this.lang } })
      },
    }
  }
  </script>

<style lang="scss" scoped>

.title{
  display: block;
  font-size: 16px;
  font-style: normal;
  line-height: 130%;
  color: #313234;
}

.message-box{
  display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 12px;
    grid-gap: 6px;
    gap: 6px;
}
.labels {
  display: flex;
  grid-gap: 8px;
  gap: 8px;
}

.article {
  margin: 0 12px;
  display: flex;
  flex-direction: column;
  padding: 20px 16px;
  word-break: break-all;
  border-radius: 8px;
  background-color: #fff;
  grid-gap: 16px;
  gap: 16px;
}

.link{
  color: #2F8DB7;
  font-weight: bold;
  text-decoration: underline;
}
.back_button{
  margin-top: 24px;
  margin-right: 16px;
  margin-left: 16px;
  display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    font-size: 16px;
    height: 52px;
    width: calc(100% - 32px);
    padding: 0 12px;
    text-align: center;
    text-decoration: none;
    box-sizing: border-box;
    border: 1px solid #313234;
    border-radius: 100px;
    background-color: #fff;
    color: #313234;
}
</style>